import { MspEdrTrialReportController } from '../controller/MspEdrTrialReportController';
import { BaseAdaptableWebComponent } from '../../framework/BaseAdaptableWebComponent';
import { EdrTrialReportData } from '@nirvana/shared/dtos/types/dashboards/common';

export class MspEdrTrialReportWebComponent extends BaseAdaptableWebComponent {

  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: MspEdrTrialReportController,
    });
  }

  get edrTrialReportData(): EdrTrialReportData {
    const value = this.getAttribute('edr-trial-report-data');
    return value ? JSON.parse(value) : {};
  }

  set edrTrialReportData(value: EdrTrialReportData) {
    this.setAttribute('edr-trial-report-data', JSON.stringify(value));
  }
}